module.exports = __webpack_public_path__ + "22c1ca838813dec9f5e3a007ff983621.svg";